import { render, staticRenderFns } from "./ShopeeConnectShippingFee.vue?vue&type=template&id=2d714b00&scoped=true&"
import script from "./ShopeeConnectShippingFee.vue?vue&type=script&lang=js&"
export * from "./ShopeeConnectShippingFee.vue?vue&type=script&lang=js&"
import style1 from "./ShopeeConnectShippingFee.vue?vue&type=style&index=1&id=2d714b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d714b00",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d714b00')) {
      api.createRecord('2d714b00', component.options)
    } else {
      api.reload('2d714b00', component.options)
    }
    module.hot.accept("./ShopeeConnectShippingFee.vue?vue&type=template&id=2d714b00&scoped=true&", function () {
      api.rerender('2d714b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Connector/components/Shopee/ShopeeConnectShippingFee.vue"
export default component.exports